


















































































































































import { defineComponent, Ref, ref } from '@vue/composition-api';
import {
  ThreadDisplay,
  Comment,
  AllCommentsRequest,
  CommentSortType,
  ThreadStatus,
} from '@oare/types';
import sl from '@/serviceLocator';
import { DataTableHeader } from 'vuetify';
import useQueryParam from '@/hooks/useQueryParam';
import CommentItemDisplay from '@/components/CommentItemDisplay/index.vue';
import { formatTimestamp } from '@/utils';
import { OareDataTableOptions } from '@/components/base/OareDataTable.vue';

export default defineComponent({
  name: 'CommentView',
  components: { CommentItemDisplay },
  props: {
    isUserComments: {
      type: Boolean,
      default: true,
    },
  },

  setup({ isUserComments }) {
    const isViewingThread = ref(false);
    const threadDisplays: Ref<ThreadDisplay[]> = ref([]);
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');
    const serverCount = ref(0);
    const selectedComments: Ref<Comment[]> = ref([]);
    const selectedThreadDisplay = ref<ThreadDisplay>({
      thread: {
        uuid: '',
        name: null,
        referenceUuid: '',
        status: 'New',
        route: '',
      },
      word: '',
      latestCommentDate: new Date(),
      comments: [],
    });
    const status = useQueryParam('status', '', true);
    const name = useQueryParam('name', '', true);
    const item = useQueryParam('item', '', true);
    const comment = useQueryParam('comment', '', true);
    const statusOptions: ThreadStatus[] = [
      'New',
      'In Progress',
      'Pending',
      'Completed',
    ];
    const tableHeaders: Ref<DataTableHeader[]> = ref([
      { text: 'Status', value: 'status', width: '10%' },
      { text: 'Thread', value: 'name', width: '20%' },
      { text: 'Item', value: 'item', width: '15%' },
      { text: 'Comments', value: 'comments', width: '40%', sortable: false },
      { text: 'Timestamp', value: 'timestamp', width: '15%' },
    ]);

    const getAllThreadsWithComments = async ({
      page,
      rows,
      sortBy,
      sortDesc,
    }: OareDataTableOptions) => {
      try {
        const request: AllCommentsRequest = {
          filters: {
            status: status.value
              ? (status.value as ThreadStatus)
              : ('All' as ThreadStatus),
            thread: name.value,
            item: item.value,
            comment: comment.value,
          },
          sort: {
            type: sortBy as CommentSortType,
            desc: sortDesc,
          },
          pagination: {
            page,
            limit: rows,
          },
          isUserComments,
        };

        const response = await server.getAllThreads(request);
        threadDisplays.value = response.threads;
        serverCount.value = response.count;
      } catch (err) {
        actions.showErrorSnackbar('Failed to get threads', err as Error);
      }
    };

    const formatCommentText = (idx: number, text: string, extended = false) => {
      if (extended) {
        return idx + 1 + '. ' + text;
      }

      return (
        idx +
        1 +
        '. ' +
        (text.length > 80 ? text.substr(0, 80) + '. . .' : text)
      );
    };

    const setSelectedComments = (comments: Comment[]) => {
      selectedComments.value = comments;
    };

    const setupThreadDialog = (threadDisplay: ThreadDisplay) => {
      isViewingThread.value = true;
      selectedThreadDisplay.value = threadDisplay;
    };

    const getItemComments = (item: ThreadDisplay) => {
      return item.comments;
    };

    return {
      setupThreadDialog,
      selectedThreadDisplay,
      isViewingThread,
      status,
      name,
      item,
      comment,
      statusOptions,
      threadDisplays,
      serverCount,
      tableHeaders,
      formatTimestamp,
      formatCommentText,
      selectedComments,
      setSelectedComments,
      getAllThreadsWithComments,
      getItemComments,
    };
  },
});
